
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
.grid-container-wrapper {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 12px;
  padding-right: 12px;
  box-sizing: border-box;
}
@media (min-width: 560px) {
  .grid-container-wrapper {
    max-width: 536px;
  }
}
@media (min-width: 768px) {
  .grid-container-wrapper {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .grid-container-wrapper {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .grid-container-wrapper {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .grid-container-wrapper {
    max-width: 1320px;
  }
}
.grid-container-wrapper.fluid {
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-left: 24px !important;
  padding-right: 24px !important;
}
@media (min-width: 992px) {
  .grid-container-wrapper.fluid {
    padding-left: 32px !important;
    padding-right: 32px !important;
  }
}
@media (min-width: 1200px) {
  .grid-container-wrapper.fluid {
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
}
.grid-container-wrapper.fluid.padding-sm {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
@media (min-width: 992px) {
  .grid-container-wrapper.fluid.padding-sm {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }
}
@media (min-width: 1200px) {
  .grid-container-wrapper.fluid.padding-sm {
    padding-left: 32px !important;
    padding-right: 32px !important;
  }
}
`;
